import { render, staticRenderFns } from "./CountNewOrdersPro.vue?vue&type=template&id=538bf0df&"
import script from "./CountNewOrdersPro.vue?vue&type=script&lang=js&"
export * from "./CountNewOrdersPro.vue?vue&type=script&lang=js&"
import style0 from "./CountNewOrdersPro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports